module.exports = __webpack_public_path__ + "img/sTriMnky_193x205.ade80ad4.png";